function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-206.9 -105.76)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.26458 0 0 .26458 182.74 99.1)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(46.76 -5.1174)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(44.565 30.306)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12 0c-6.583 0-12 5.417-12 12s5.417 12 12 12 12-5.417 12-12-5.417-12-12-12zm0 2.478c5.256 0 9.522 4.266 9.522 9.522s-4.266 9.522-9.522 9.522-9.522-4.266-9.522-9.522c0-0.885 0.12-1.741 0.347-2.554 0.43738 0.6371 1.0233 1.1582 1.7072 1.5181 0.68385 0.36 1.445 0.548 2.2178 0.5479 1.2628-5e-4 2.4737-0.5024 3.3667-1.3953 0.8929-0.89298 1.3948-2.1039 1.3953-3.3667 2e-4 -0.77292-0.1879-1.5342-0.5481-2.2181-0.3601-0.68388-0.8815-1.2697-1.5189-1.7069 0.832-0.23093 1.6915-0.34766 2.555-0.347z",
  fill: "#fff"
})))));

function SvgInsomnia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6.35mm",
    height: "6.35mm",
    viewBox: "0 0 6.35 6.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsomnia);
export default __webpack_public_path__ + "static/media/insomnia.d3494b00.svg";
export { ForwardRef as ReactComponent };